import { useQuery } from 'react-query'
import { config } from 'config'
import { AuthContainer } from 'containers'
import { callAxios, CustomAxiosError } from 'utils/api'
import { MessageGetResponse } from 'pages/admin/supplierMessaging/types'

type MessageRoles = 'Site Administrator' | 'Supplier'

const { SECURE_BASE_URL } = config!

const getMessages = async (role: MessageRoles): Promise<MessageGetResponse> => {
  const { response: messagesResponse } = await callAxios<{
    response: MessageGetResponse | undefined
  }>({
    url: `${SECURE_BASE_URL}/getMessages?role=${role}&operation=read`,
    method: 'GET',
  })

  messagesResponse?.sort((a, b) => `${b.startDate}T${b.startTime}`.localeCompare(`${a.startDate}T${a.startTime}`))

  return messagesResponse ?? []
}

export const useGetMessages = (role: MessageRoles) => {
  const { isAuthenticated } = AuthContainer.useContainer()

  const {
    status: getMessagesStatus,
    data: messagesData,
    error: getMessagesError,
  } = useQuery<MessageGetResponse, CustomAxiosError>(['supplierMessages/get', role], () => getMessages(role), {
    enabled: !!isAuthenticated,
  })

  return { getMessagesStatus, messagesData, getMessagesError }
}
